<template>
  <div id="app">
    <!-- Image Map Generated by http://www.image-map.net/ -->
    <img :src="map" usemap="#image-map" :style="{ maxWidth: '100%' }" />

    <map name="image-map">
      <area
        href="javascript:void(0);"
        :key="graph.title"
        v-for="graph in areas"
        :alt="graph.title"
        :title="graph.title"
        :coords="graph.coords"
        :shape="graph.shape"
        @click="handleOnClick(graph)"
      />
    </map>
    <VueEasyLightbox
      :visible="toggler"
      :imgs="mapImages"
      type="image"
      :disableLocalStorage="true"
      @hide="handleClose"
    />
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox';
import ImageMap from "image-map";
import data, { BASE_URL } from "./data";

export default {
  name: "TestMap",
  components: { VueEasyLightbox },
  data() {
    return {
      toggler: false,
      images: [],
      map: BASE_URL + "/map.jpg",
      baseURL: "",
      areas: data,
    };
  },
  computed: {
    mapImages() {
      return this.images.map((img) => `${this.baseURL}${img}`);
    },
  },
  mounted() {
    setTimeout(() => {
      ImageMap("img[usemap]");
    }, [500]);
  },
  methods: {
    handleOnClick(event) {
      this.$nextTick(() => {
        this.toggler = !this.toggler;
        this.images = event.images;
      });
    },
    handleClose() {
      this.toggler = false;
      this.images = [];
    },
  },
};
</script>
<style scoped>
[data-test-class="source-main-wrapper"] {
  display: none;
}
</style>
